import { Injectable, inject } from '@angular/core';
import { LOCAL_STORAGE } from '@ng-web-apis/common';
import { BehaviorSubject } from 'rxjs';

/** A list opened by the user and when. */
export interface RecentList {
  id: number;
  at: number;
}

const STORAGE_KEY = 'hunter.recentLists';
const LIMIT = 10;

/**
 * The lists the user opened last, newest first, kept in the local storage of
 * the browser. A storage that cannot be read or written (private mode, full,
 * blocked) only loses the history.
 */
@Injectable({ providedIn: 'root' })
export class RecentListsService {
  private storage = inject<Storage>(LOCAL_STORAGE);
  private recent = new BehaviorSubject<RecentList[]>(this.read());

  public readonly recent$ = this.recent.asObservable();

  public record(id: number, at = Date.now()) {
    const recent = [
      { id, at },
      ...this.recent.value.filter((x) => x.id !== id),
    ].slice(0, LIMIT);
    this.recent.next(recent);
    try {
      this.storage.setItem(STORAGE_KEY, JSON.stringify(recent));
    } catch {
      // The history lives on in memory.
    }
  }

  private read(): RecentList[] {
    try {
      const value = JSON.parse(this.storage.getItem(STORAGE_KEY) ?? '[]');
      return Array.isArray(value)
        ? value
            .filter(
              (x): x is RecentList =>
                typeof x?.id === 'number' && typeof x?.at === 'number'
            )
            .slice(0, LIMIT)
        : [];
    } catch {
      return [];
    }
  }
}
